module.exports = __webpack_public_path__ + "img/exam_vr_info_itback.e72876c4.png";